import { useRef, useState, useLayoutEffect } from 'react';
import { getEventAesthetic } from './registry';

// Web port of app/components/eventAesthetics/AestheticDetailBanner.jsx. The
// event-detail hero banner with its aesthetic applied, inset slightly from the
// edges so the decorative frame has room to bleed. Returns null when the event
// has no real aesthetic (caller renders the plain banner) or has no image.

function useSize() {
  const ref = useRef(null);
  const [size, setSize] = useState(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const measure = () => {
      const r = el.getBoundingClientRect();
      setSize((prev) => (prev && prev.width === r.width && prev.height === r.height) ? prev : { width: r.width, height: r.height });
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  return [ref, size];
}

export default function AestheticDetailBanner({ event }) {
  const aesthetic = getEventAesthetic(event?.aesthetic);
  const [ref, size] = useSize();
  if (!aesthetic || !event?.bannerImageUrl) return null;
  const Frame = aesthetic.Frame;

  return (
    <div style={{ position: 'relative', margin: '10px 14px 4px' }}>
      <div
        ref={ref}
        style={{ position: 'relative', width: '100%', height: 200, borderRadius: 14, overflow: 'hidden', backgroundColor: aesthetic.surface || '#1c1c1e' }}
      >
        <img src={event.bannerImageUrl} alt="" style={{ width: '100%', height: 200, objectFit: 'cover', display: 'block' }} />
      </div>
      {size && Frame ? <Frame w={size.width} h={size.height} radius={14} accent={aesthetic.accent} /> : null}
    </div>
  );
}
